<template>
  <aside class="aside aside-fixed">
    <div class="aside-header">
      <a href="/" class="aside-logo">har<span>Vest</span></a>
      <a href="" class="aside-menu-link">
        <i data-feather="menu"></i>
        <i data-feather="x"></i>
      </a>
    </div>
    <div class="aside-body">
      <div class="aside-loggedin">
        <div class="d-flex align-items-center justify-content-start">
          <a href="" class="avatar"><img src="https://ca.slack-edge.com/EHTHJQWQ2-WLK2ENRQV-db5dc6d265f4-512" class="rounded-circle" alt=""></a>
          <div class="aside-alert-link">
            <a href="" class="new" data-bs-toggle="tooltip" title="You have 2 unread messages"><i data-feather="message-square"></i></a>
            <a href="" class="new" data-bs-toggle="tooltip" title="You have 4 new notifications"><i data-feather="bell"></i></a>
            <a href="" v-on:click="logout" data-bs-toggle="tooltip" title="Sign out"><i data-feather="log-out"></i></a>
          </div>
        </div>
        <div class="aside-loggedin-user">
          <a href="#loggedinMenu" class="d-flex align-items-center justify-content-between mg-b-2" data-bs-toggle="collapse">
            <h6 class="tx-semibold mg-b-0">Abayomi Mosaku</h6>
            <i data-feather="chevron-down"></i>
          </a>
          <p class="tx-color-03 tx-12 mg-b-0">Administrator</p>
        </div>
        <div class="collapse" id="loggedinMenu">
          <ul class="nav nav-aside mg-b-0">
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="edit"></i> <span>Edit Profile</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="user"></i> <span>View Profile</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="settings"></i> <span>Account Settings</span></a></li>
            <li class="nav-item"><a href="" class="nav-link"><i data-feather="help-circle"></i> <span>Help Center</span></a></li>
            <li class="nav-item"><a href="" v-on:click="logout" class="nav-link"><i data-feather="log-out"></i> <span>Sign Out</span></a></li>
          </ul>
        </div>
      </div><!-- aside-loggedin -->
      <ul class="nav nav-aside">
        <li class="nav-label">Members Relationship Mgt.</li>
        <li class="nav-item" :class="{active: $route.path === '/contact-dashboard'}">
          <a href="/contact-dashboard" class="nav-link"><i data-feather="shopping-bag"></i> <span>Dashboard</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/users'}">
          <a href="/users" class="nav-link"><i data-feather="pie-chart"></i> <span>Contacts</span></a>
        </li>
        <li class="nav-item" :class="{active: $route.path === '/keep'}">
          <a href="/keep" class="nav-link"><i data-feather="globe"></i> <span>Report Dashboard</span></a>
        </li>
        <li class="nav-item">
          <a href="/watch" class="nav-link"><i data-feather="globe"></i> <span>User Mode</span></a>
        </li>

        <li class="nav-label mg-t-25">Admin Apps</li>
        <li class="nav-item"><a href="/sms" class="nav-link"><i data-feather="inbox"></i> <span>SMS</span></a></li>
        <li class="nav-item"><a href="app-contacts.html" class="nav-link"><i data-feather="users"></i> <span>Profile</span></a></li>
        <li class="nav-item"><a href="/users" class="nav-link"><i data-feather="calendar"></i> <span>Users</span></a></li>
        <li class="nav-item"><a href="app-chat.html" class="nav-link"><i data-feather="message-square"></i> <span>Integrations</span></a></li>
        <li class="nav-item"><a href="app-file-manager.html" class="nav-link"><i data-feather="file-text"></i> <span>Reports</span></a></li>
        <li class="nav-item"><a href="app-mail.html" class="nav-link"><i data-feather="mail"></i> <span>Files</span></a></li>

        <li class="nav-label mg-t-25">System</li>
        <li class="nav-item" :class="{active: $route.path === '/configuration'}">
          <a href="/configuration" class="nav-link"><i data-feather="user"></i> <span>Configurations</span></a>
<!--          <ul>-->
<!--            <li><a href="page-profile-view.html">Tags & Categories</a></li>-->
<!--            <li><a href="page-connections.html">Departments</a></li>-->
<!--            <li><a href="page-groups.html">Groups</a></li>-->
<!--            <li><a href="page-events.html">Events</a></li>-->
<!--          </ul>-->
        </li>

        <li class="nav-item with-sub">
          <a href="" class="nav-link"><i data-feather="file"></i> <span>Other Pages</span></a>
          <ul>
            <li><a href="page-timeline.html">Timeline</a></li>
          </ul>
        </li>
        <li class="nav-label mg-t-25">User Interface</li>
        <li class="nav-item"><a href="../../components" class="nav-link"><i data-feather="layers"></i> <span>Components</span></a></li>
        <li class="nav-item"><a href="../../collections" class="nav-link"><i data-feather="box"></i> <span>Collections</span></a></li>
      </ul>
    </div>
  </aside>
</template>

<script>

export default {
  name: "SideBarAsideFix",
  methods:{
    logout(){
      localStorage.clear();
      this.$router.push({name: 'Login'});
    }
  },
}
</script>
